import axios from "axios"
import { getData } from 'lib/axios'

export const getIpAddress = async () => {
    return axios.get('https://ifconfig.me').then(getData)
}

export const ipLookup = async (ip) => {
    return axios.get(`https://api.country.is/${ip}`).then(getData)
}